var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recorderbutton"},[_c('canvas',{ref:"canvas"}),_c('img',{ref:"bt",staticClass:"buttonSkin",style:(_vm.btStyles),attrs:{"src":require("@/assets/audioplayer/reccord_button.svg"),"alt":"reccord"}})])}
var staticRenderFns = []

export { render, staticRenderFns }